// extracted by mini-css-extract-plugin
module.exports = {"clickable":"LinkEntity_clickable__SMVdN"};